"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.list = exports.search_top_selling_places = exports.search_popular_places = exports.search_trending_places = void 0;
exports.search_trending_places = "/api/search/hotel/v1/places/trending{?region,brand,limit}";
exports.search_popular_places = "/api/search/popular-places{?region,brand,limit}";
exports.search_top_selling_places = "/api/search/hotel/v1/places/top-selling{?region,brand,country,state,limit}";
exports.list = "/api/search/hotel/v1/list{?offerType,searchType,placeIds,distanceEq,region,occupancy,hasPromotions,showUnavailableResult,brand}";
